const schedule = {
  music: [
    {
      name: "Classical Vocal Solo (Hindustani/Carnatic)",
      details: "Classical Vocal Solo (HindustaniCarnatic)",
    },
    {
      name: "Classical Instrumental Solo (Percussion Tala Vadya)",
      details: "Classical Instrumental Solo (Percussion Tala Vadya)",
    },
    {
      name: "Classical Instrumental Solo (Non-Percussion Swara Vadya)",
      details: "Classical Instrumental Solo (Non-Percussion Swara Vadya)",
    },
    {
      name: "Light Vocal Solo (Indian)",
      details: "Light Vocal Solo (Indian)",
    },
    {
      name: "Western Vocal Solo",
      details: "Western Vocal Solo",
    },
    {
      name: "Group Song (Indian)",
      details: "Group Song (Indian)",
    },
    {
      name: "Group Song (Western)",
      details: "Group Song (Western)",
    },
    {
      name: "Folk Orchestra",
      details: "Folk Orchestra",
    },
  ],
  dance: [
    {
      name: "Folk / Tribal Dance",
      details: "Folk  Tribal Dance",
    },
    {
      name: "Classical Dance Solo",
      details: "Classical Dance Solo",
    },
  ],
  literary: [
    {
      name: "Quiz",
      details: "Quiz",
    },
    {
      name: "Debate",
      details: "Debate",
    },
    {
      name: "Elocution",
      details: "Elocution",
    },
  ],
  theatre: [
    {
      name: "Skit",
      details: "Skit",
    },
    {
      name: "Mime",
      details: "Mime",
    },
    {
      name: "Mimicry",
      details: "Mimicry",
    },
    {
      name: "One Act Play",
      details: "One Act Play",
    },
  ],
  "fine-arts": [
    {
      name: "Collage",
      details: "Collage",
    },
    {
      name: "Rangoli",
      details: "Rangoli",
    },
    {
      name: "Cartooning",
      details: "Cartooning",
    },
    {
      name: "Installation",
      details: "Installation",
    },
    {
      name: "Poster Making",
      details: "Poster Making",
    },
    {
      name: "Clay Modelling",
      details: "Clay Modelling",
    },
    {
      name: "On Spot Painting",
      details: "On Spot Painting",
    },
    {
      name: "Spot Photography",
      details: "Spot Photography",
    },
  ],
};

export default schedule;
